import bsm from '@/assets/bsm.png';
import icAi from '@/assets/icAi.svg';
import icBack from '@/assets/icBack.svg';
import icM from '@/assets/icM.svg';
import icSend from '@/assets/icSend.svg';
import icSendDisabled from '@/assets/icSendDisabled.svg';
import icBG from '@/assets/icBg.png';
import icArrowLeft from '@/assets/icArrowLeft.svg';
import icDrop from '@/assets/icDrop.svg';
import bgChat from '@/assets/bgChat.png';
// import earth from '@/assets/earth.png';
import earth1 from '@/assets/earth.jpg';
import bg1 from '@/assets/bg1.png';
import icMail from '@/assets/icMail.svg';
import icNews from '@/assets/icNews.svg';
import icBackGreen from '@/assets/icBackGreen.svg';
import icBsm from '@/assets/icBsm.png';
import news11 from '@/assets/11.png';
import news12 from '@/assets/12.png';
import news13 from '@/assets/13.png';
import news14 from '@/assets/14.png';
import news15 from '@/assets/15.png';
import icMailFilled from '@/assets/icMailF.svg';
import icWeb from '@/assets/icWeb.svg';
import news21 from '@/assets/21.png';
import news22 from '@/assets/22.png';
import news23 from '@/assets/23.png';
import news24 from '@/assets/24.png';
import news25 from '@/assets/25.png';
import news31 from '@/assets/31.png';
import news32 from '@/assets/32.png';
import news33 from '@/assets/33.png';
import news34 from '@/assets/34.png';
import news35 from '@/assets/35.png';

export const ASSETS = {
  bsm,
  icAi,
  icBack,
  icM,
  icSend,
  icSendDisabled,
  icBG,
  icArrowLeft,
  icDrop,
  bgChat,
  // earth,
  bg1,
  earth1,
  icMail,
  icNews,
  icBackGreen,
  icBsm,
  news11,
  news12,
  news13,
  news14,
  news15,
  icMailFilled,
  icWeb,
  news21,
  news22,
  news23,
  news24,
  news25,
  news31,
  news32,
  news33,
  news34,
  news35,
};
